import Vue from 'vue'
import Router from 'vue-router'
import Root from '@/modules/Root'
import Details from '@/modules/AtomicChain/pages/Details'
import newsDetails from '@/modules/AtomicChain/pages/newsDetails'
import picList from '@/modules/AtomicChain/pages/picList'
import picDetails from '@/modules/AtomicChain/pages/picDetails'
// import downLoad from '@/modules/AtomicChain/pages/downLoad'
// import AtomicChain from '../modules/AtomicChain/router';
import videoList from '@/modules/AtomicChain/pages/videoList'
import teamMemberDetail from '@/modules/AtomicChain/pages/teamMemberDetail'
import audiodetail from '@/modules/AtomicChain/pages/audiodetail'
import audioList from '@/modules/AtomicChain/pages/audioList'
import infos from '@/modules/AtomicChain/pages/infos'
import videoPlayer from '@/modules/AtomicChain/pages/videoPlayer'
import pdfCheck from '@/modules/AtomicChain/pages/pdf'
import personalIntroduction from '@/modules/AtomicChain/pages/personalIntroduction'

Vue.use(Router);

const routes = [
    // {
    //     path: '/',
    //     redirect: '/AtomicChain/home', //跳转到首页
    //     name: 'Root',
    //     component: Root
    // },
    {
        path: '/',
        // redirect: '/AtomicChain/home', //跳转到首页
        name: 'DCHome',
        // component: resolve => require(['@/modules/AtomicChain/pages/home.vue'], resolve),
        component: () => import("@/modules/AtomicChain/pages/home.vue"),
        meta: {
            keepAlive: true,
            title:"原子鏈-原子戀-原子幣-ATOS,給世界賦能"
        }
    },
    {
        path: '/videoPlayer',
        name: 'videoPlayer',
        component: videoPlayer,
    },
    {
        path: '/details',
        name: 'details',
        component: Details
    },
    {
        path: '/newsDetails',
        name: 'newsDetails',
        component: newsDetails
    },
    {
        path: '/picList',
        name: 'picList',
        component: picList
    },
    {
        path: '/picDetails',
        name: 'picDetails',
        component: picDetails
    },
    {
        path: '/videoList',
        name: 'videoList',
        component: videoList
    },
    {
        path: '/teamMemberDetail',
        name: 'teamMemberDetail',
        component: teamMemberDetail
    },
    {
        path: '/audiodetail',
        name: 'audiodetail',
        component: audiodetail
    },
    {
        path: '/audioList',
        name: 'audioList',
        component: audioList
    },
    {
        path: '/infos',
        name: 'infos',
        meta: {
            title: "關於原子鏈"
        },
        component: infos
    },
    {
        path: '/pdfCheck',
        name: 'pdfCheck',
        meta: {
            title: "白皮書"
        },
        component: pdfCheck
    },
    {
        path: '/personalIntroduction',
        name: 'personalIntroduction',
        meta: {
            title: "CEO廖望簡介"
        },
        component: personalIntroduction
    },
    {
        path: '/youtubeplayers',
        name: 'youtubeplayers',
        component: () => import("@/modules/AtomicChain/pages/youtubePlayers.vue"),
    },

    
]

export default new Router({
    // mode: 'history',  //去掉url中的#
    routes: [
        ...routes,
        // ...AtomicChain,
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js